// src/components/ProductProtectedRoute.js
//
// Like ProtectedRoute, but gates on product-level entitlement (which
// top-level tool a user may open) instead of / in addition to `role`-based
// route access. Used for City Explorer routes, which are a separate
// product from School Explorer and are not part of the ROLE_ACCESS route
// whitelist in constants/roleAccess.js.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { hasProductAccess, requiresProductChoice } from '../constants/productAccess';

export default function ProductProtectedRoute({ children, requiredProduct, allowedRoles }) {
  const location = useLocation();
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiresProductChoice(user)) {
    return <Navigate to="/select-tool" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredProduct && !hasProductAccess(user, requiredProduct)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
